<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="dedi_1"></a><p class="dedt"><em>For my mother and father</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Girls_dedi_1.vue?6f14a832